export default __webpack_public_path__ + "static/media/noFiles.43b3a498.svg";